<template>
  <div>
    <div class="pb-1">
      <span>Formato do arquivo</span>
      <v-icon size="18" class="ml-1" @click="dialog_ativo = true">mdi-help-circle</v-icon>
    </div>

    <v-dialog v-model="dialog_ativo" width="900" content-class="bra-20">
      <v-card>
        <v-card-title class="pt-5 pb-4">
          <span>Formato do arquivo</span>
          <v-spacer />
          <v-btn icon @click="dialog_ativo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <p class="mb-1 font-15 font-weight-medium">O arquivo deve: </p>

          <ul class="ml-n2 mb-4">
            <li>Ser do formato <span class="font-weight-bold">.csv</span></li>
            <li>Ser separado por ponto e virgula.</li>
            <li>Possuir 4 colunas: <span class="font-weight-bold">cod_barras, id_produto, cod_produto e preco.</span></li>
            <li>Possuir o cabeçalho.</li>
            <li>Possuir pelo menos um dos campos: <span class="font-weight-bold">cod_barras ou id_produto ou cod_produto</span>.</li>
            <li>Possuir coluna <span class="font-weight-bold">preco</span> em todas as linhas.</li>
            <li>Separar casas decimais com ponto ou virgula.</li>
          </ul>

          <v-divider />

          <div class="row">
            <div class="col-5">
              <p class="mb-0 mt-4 font-15 font-weight-medium">Usar o bloco de notas para criar o CSV</p>

              <p class="mt-2">
                cod_barras;id_produto;cod_produto;preco;<br>
                000000000001;[vazio];[vazio];0.3000;<br>
                000000000002;[vazio];[vazio];0.6000;<br>
                000000000003;[vazio];[vazio];0.9000;<br>
                000000000004;0000000004;[vazio];1.2000;<br>
                000000000005;0000000004;[vazio];1.5000;<br>
                [vazio];0000000006;000006;1.8000;<br>
                [vazio];0000000007;000007;2.1000;<br>
                [vazio];[vazio];000008;2.4000;<br>
                [vazio];[vazio];000009;2.7000;<br>
                [vazio];[vazio];000010;3.0000;<br>
              </p>
            </div>

            <v-divider vertical />

            <div class="col-7">
              <p class="mb-0 mt-4 font-15 font-weight-medium">Usar “Salvar como” do Excel para CSV UTF-8 (Delimitado por ponto e vírgula)</p>
    
              <table class="mt-2 table-com-bordas">
                <thead>
                  <tr>
                    <th class="text-left">cod_barras</th>
                    <th class="text-left">id_produto</th>
                    <th class="text-left">cod_produto</th>
                    <th class="text-left">preco</th>
                  </tr>
                </thead>
    
                <tbody>
                  <tr v-for="n in 10" :key="n">
                    <td class="text-left">{{ (n < 6) ? `${n}`.padStart(12, '0') : '' }}</td>
                    <td class="text-left">{{ (n > 3) && (n < 8) ? `${n}`.padStart(10, '0') : '' }}</td>
                    <td class="text-left">{{ n > 4 ? `${n}`.padStart(6, '0') : '' }}</td>
                    <td class="text-left">{{ Number(n * 0.3).toFixed(4) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menu: false,
      dialog_ativo: false
    }
  }
}
</script>

<style scoped>
.table-com-bordas {
  width: 70%;
  border-collapse: collapse;
  border-spacing: 0;
}
.table-com-bordas tr th, tr td {
  border: 1px solid #cbc8c8;
  padding: 0 3px;
}
</style>
